import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const Model1ValidationStatusAutocomplete = ({ setModel1ValidationStatuses, ...props }) => {
    const {t} = useTranslation("inputs");

    const statusOptions = ["VALID", "ERROR", "WARNING"]; // TODO: save the enum in a config file or fetch from the backend
    const statusLabels = statusOptions.reduce((acc, s ) => {
        acc[s] = t(`enums:model1ValidationStatus.${s}`);
        return acc;
    }, {})

    return <Autocomplete
        id="model1-validation-status-autocomplete"
        options={statusOptions}
        getOptionLabel={(status) => statusLabels[status]}
        filterOptions={(x) => x}
        onChange={(e, value) => setModel1ValidationStatuses(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('model1ValidationStatusAutocomplete.label')}
                     placeholder={t('model1ValidationStatusAutocomplete.placeholder')}
            />
        )}
        multiple
        {...props}
    />
}

export default Model1ValidationStatusAutocomplete;